import mapDraftToActiveInspection from './mapDraftToActiveInspection';

export default {
    mapDraftToActiveInspection,
};
